export default __webpack_public_path__ + "static/media/dont-close.d29eaba0.svg";